import React from 'react';
import ConvocationPageShell from '../../components/ConvocationPageShell';
import GiyusStatic from './GiyusStatic';

const Giyus = () => (
  <ConvocationPageShell
    strapiApiId="convocation-giyus"
    defaultTitle="Giyus"
    StaticFallback={GiyusStatic}
  />
);

export default Giyus;
